import { InjectionToken } from '@angular/core';

import { IRoutingService } from './routing.types';

export const ROUTING_SERVICE = new InjectionToken<IRoutingService>('ROUTING_SERVICE');
